export class DetailUsers {
    program : {
      name: string;
      startDate: string;
      endDate: string;
    }
    users?: [
        {
            id?: string;
            name: string;
            middleName: string;
            lastName: string;
            secondLastName: string;
            phone: string;
            email: string;
            userNumber: string;
            dateCreated: number;
            active: boolean;
            verified: boolean;
            companyName: string;
            companyId: string;
            ine: string;
            passport: string;
            belongsToProgram: boolean;
            belongsToIhunterProgram: boolean;
            level: number;
      }
    ];
  constructor(formData?: any) {
    let data: any = !formData ? {} : formData;
    this.program = data.program ||{
      name: data.name || null,
      startDate:  data.startDate || null,
      endDate: data.endDate || null,
    }
    this.users = data.users || {
      id: null, 
      name: null, 
      middleName: null, 
      lastName: null, 
      secondLastName: null, 
      phone: null, 
      email: null, 
      userNumber: null, 
      dateCreated: null, 
      active: null, 
      verified: null, 
      companyName: null, 
      companyId: null, 
      ine: null, 
      passport: null, 
      belongsToProgram: null, 
      belongsToIhunterProgram:null, 
      level: null
    }
  }
}
